module.exports = __webpack_public_path__ + "static/media/BBFiller.20c6caf9.png";